import { render, staticRenderFns } from "./UsergroupsOverview.vue?vue&type=template&id=862f16d6&"
import script from "./UsergroupsOverview.vue?vue&type=script&lang=js&"
export * from "./UsergroupsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports